import { useParams } from 'react-router-dom';
import { LicensingGuard } from '../../../components/saas/LicensingGuard';
import { useAdminI18n } from '../../../lib/i18n/use-admin-i18n';

/**
 * Product demo page: entry route wrapped with useLicensingCheck + LicensingGuard.
 * Blocks access and shows MACHINE_MISMATCH banner when not allowed.
 */
export function ProductDemoPage() {
  const { productCode } = useParams<{ productCode: string }>();
  const { page } = useAdminI18n();
  const code = productCode ?? '';

  return (
    <LicensingGuard productCode={productCode} productName={productCode}>
      <div className="space-y-2 p-2">
        <h1 className="text-3xl font-bold">{page('product_demo', 'title', { code })}</h1>
        <p className="text-muted-foreground">
          Nội dung sản phẩm chỉ hiển thị khi bản quyền hợp lệ trên thiết bị này.
        </p>
        <div className="glass-card p-6">
          <p className="text-sm text-muted-foreground">
            Đây là vùng nội dung được bảo vệ bởi licensing check. Khi MACHINE_MISMATCH hoặc
            không được phép, chỉ banner và thông báo chặn được hiển thị.
          </p>
        </div>
      </div>
    </LicensingGuard>
  );
}
